import { generatePath } from "react-router-dom";
import CollectionLink from "./CollectionLink";

export default class TaMerchantCollectionLink extends CollectionLink {
  constructor(merchantId, name, icon, path, authenticationName, taMerchantId, subLinks, subtitle) {
    super(merchantId, name, icon, path, authenticationName, subLinks, subtitle);
    this.taMerchantId = taMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, taMerchantId: this.taMerchantId });
  }
}
